import { Box } from '@mui/material';
import styled from 'styled-components';

import { getTheme } from '@commons/utils/theme';

const theme = getTheme();

// Base component for data cells
export const DataCell = styled(Box)`
  width: 60px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputCell = styled(DataCell)`
  background-color: ${(props) =>
    props.isDisabled ? theme.colors.greys.lighty : theme.colors.greys.lightest};
  border: ${(props) => {
    if (props.isDisabled) {
      return 'none';
    }

    if (props.isFocused || props.isOperatorForecast || props.hasBeenModified) {
      return `1px solid ${theme.colors.greys.darkest}`;
    }
    return `1px solid ${theme.colors.greys.lighty}`;
  }};
`;

// Universal conditional cell
export const ToProduceCell = styled(DataCell)`
  background-color: ${theme.colors.brand.secondaryLight};
  border: 1px solid ${theme.colors.brand.secondary};
`;

// Container for the 4 cells of a timeslot
export const TimeSlotContainer = styled(Box)`
  display: flex;
  gap: 8px;
  width: 100%;
`;

// Specialized container for entity timeslot headers (recipes/ingredients)
export const EntityTimeSlotHeaderContainer = styled(Box)`
  display: flex;
  text-align: center;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100% !important;
  height: 100%;
  min-width: 100%;
  max-width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 8px;
  box-sizing: border-box;
`;

// Container for entity timeslot cells (recipes/ingredients)
export const EntityTimeSlotCellContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 8px;

  align-items: ${({ isTotalCell }) => (isTotalCell ? 'flex-start' : 'center')};
`;

// Container for total
export const TotalContainer = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  height: 100%;
`;

// Container for total numbers (left part)
export const TotalNumbersContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
`;
